export interface AuthPayload {
  email: string;
  password: string;
  saveCredentials: boolean;
}

export interface AuthResponse {
  token: string;
  refresh_token: string;
  useSessionStorage?: boolean;
}

export interface PasswordRestorePayload {
  token: string;
  password: string;
}

export enum InvitationTokenStatus {
  VALID = 'valid',
  INVALID = 'invalid',
}

export enum AuthTokenValidityState {
  VALID = 'valid',
  EXPIRED = 'expired',
  INVALID = 'invalid',
}
